/** Assets CDN — Marketing en Movimiento (showSlug: marketingenmovimiento). */
export const SHOW_LOGO_MARKETING_EN_MOVIMIENTO_URL =
  'https://files.tnonetwork.com/shows/logo/marketingenmovimiento.png';

export const SHOW_COVER_MARKETING_EN_MOVIMIENTO_URL =
  'https://files.tnonetwork.com/shows/cover/marketingenmovimiento.png';

/** Imagen de conductora / programa para secciones hero y métricas. */
export const HOST_PROFILE_IMAGE_URL = SHOW_COVER_MARKETING_EN_MOVIMIENTO_URL;
